import { ApiResult, RequestError, isDomainError, request, safeRequest } from '@synergy/api';

import { ErrorMessage } from '../../../../../../common/models/enums/error-message';
import { SupplierSpecialOffer } from '../../../models/supplier-special-offer';
import { SupplierSpecialOffersDetailOverviewRequest } from '../models/supplier-special-offers-detail-overview-request';

export class SupplierSpecialOffersDetailOverviewApi {
    constructor(protected baseUrl: string) {}

    public getSupplierSpecialOffersDetail(id: number): Promise<ApiResult<SupplierSpecialOffer>> {
        return safeRequest(
            () => request.get(`${this.baseUrl}/supplier-special-offers/${id}`),
            response => response.data
        );
    }

    public updateSupplierSpecialOffersDetail = (
        supplierSpecialOffers: SupplierSpecialOffersDetailOverviewRequest
    ): Promise<ApiResult<SupplierSpecialOffer>> => {
        return safeRequest(
            () =>
                request.post(
                    `${this.baseUrl}/supplier-special-offers/${supplierSpecialOffers.id}`,
                    supplierSpecialOffers
                ),
            response => response.data,
            overviewErrorHandler
        );
    };

    public createSupplierSpecialOffersDetail = (
        supplierSpecialOffers: SupplierSpecialOffersDetailOverviewRequest
    ): Promise<ApiResult<SupplierSpecialOffer>> => {
        return safeRequest(
            () => request.post(`${this.baseUrl}/supplier-special-offers`, supplierSpecialOffers),
            response => response.data,
            overviewErrorHandler
        );
    };
}

const overviewErrorHandler = (error?: RequestError) => {
    if (isDomainError(error) && error.title === ErrorMessage.NonUniqueProperties) {
        return [{ property: 'path', error: 'app.error.nonUniquePath' }];
    }
    return [];
};
